// extracted by mini-css-extract-plugin
module.exports = {"style":{"fontFamily":"'Syncopate', 'Syncopate Fallback'","fontStyle":"normal"},"className":"__className_de308d"};